export const TEMPORADA_ESTADOS = ['planeada', 'abierta', 'cerrada']

export const ESTADO_LABELS = {
  planeada: 'Planeada',
  abierta: 'Abierta',
  cerrada: 'Cerrada',
}

// Solo se puede editar estructura (planes/cargos/asignaciones) en planeada/abierta
export const puedeEditarTemporada = (temporada) =>
  !!temporada && temporada.estado !== 'cerrada' && TEMPORADA_ESTADOS.includes(temporada.estado)
